module.exports = __webpack_public_path__ + "static/media/BerwickB.06e53162.png";